import { useNavigate } from "react-router";

import { Box } from "@design-system/Box/Box";
import { Button } from "@design-system/Button/Button";
import { Card } from "@design-system/Card/Card";
import { Lottie } from "@design-system/Lottie/Lottie";
import { Text } from "@design-system/Text/Text";

import { routes } from "@pages/routes";

import classes from "./EmailRequest.page.module.css";

export const EmailRequestPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(routes.login.index.$path(), {
      viewTransition: true,
      replace: true,
    });
  };

  return (
    <div className={classes.container}>
      <Card>
        <Card.Header>
          <Box direction="column" gap={8}>
            <Text size={24} weight={600}>
              Email sent!
            </Text>
            <Text size={14} weight={400} color="textSecondary">
              We've sent a magic link to your email address. Please check your
              email and click the link to continue.
            </Text>
          </Box>
        </Card.Header>
        <Card.Body>
          <Lottie lottie="emailSent" />
        </Card.Body>
        <Card.Footer justify="start">
          <Button
            variant="outlined"
            icon="faChevronLeft"
            onClick={handleGoBack}
          >
            Back
          </Button>
        </Card.Footer>
      </Card>
    </div>
  );
};
